import { GetFloorsResponse } from 'src/model/api/v2/data-contracts';

class FloorProvider {

  private getFloorsResponse: GetFloorsResponse|null = null;

  setFloors(getFloorsResponse: GetFloorsResponse) {
    this.getFloorsResponse = getFloorsResponse;
  }

  getFloorName(floorId: number): string {
    if (this.getFloorsResponse == null) {
      console.log('getFloorResponse is null when FloorProvider.getFloorName called')
    }
    const floor = this.getFloorsResponse!!.floors.find((floor) => floor.id === floorId);
    if (floor == null) {
      console.log('Floor not found with id ' + floorId)
    }
    return floor?.floor_name ?? '';
  }

  getFloorCount(): number {
    return this.getFloorsResponse?.floors?.length ?? 0;
  }

  getFirstFloorId(): number {
    return this.getFloorsResponse?.floors[0].id ?? 0;
  }
}

export const floorProvider = new FloorProvider();